import ApiService from "./api.service";
export default class RatingService extends ApiService {
    static base_url = `${super.base_url}/ratings`;
}
